import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DialogCloseButton from "@profilog/commons/components/DialogCloseButton";

export default function EndCooperationDialog({ trigger, onConfirmClick }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState();

    return (
        <Fragment>
            {trigger && trigger(() => setOpen(true))}
            <Dialog open={open} onClose={handleClose}>
                <DialogCloseButton onClick={handleClose} />
                <DialogTitle>{t("communications.CooperationRequests.EndCooperation.EndCooperation")}</DialogTitle>

                <DialogContent>
                    <p>{t("communications.CooperationRequests.EndCooperation.ReallyEndCooperation")}</p>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" color="error" onClick={() => handleConfirm()} tw="normal-case">
                        {t("communications.CooperationRequests.EndCooperation.YesReallyEndCooperation")}
                    </Button>

                    <Button variant="contained" color="success" onClick={handleClose} tw="normal-case">
                        {t("communications.CooperationRequests.EndCooperation.NoDoNotEndCooperation")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );

    function handleConfirm() {
        onConfirmClick();
        handleClose();
    }

    function handleClose() {
        setOpen(false);
    }
}
